/*eslint-disable */
import React from 'react';
import ReactDOM from 'react-dom';
import {PasswordStrength, fetchPasswordRules} from '@treatwell/ui';
import {validatePassword} from './profile/view/validate-password';
import events from '../../common/event-aggregator';
import {attachShowHidePasswordHandler} from './show-hide-password';
import {getLanguageCode} from '../../common/util/language';

define(function (require) {
  var $ = require('jquery');
  var pageConfig = require('common/page-config');
  var config = require('common/page-config');
  var loginEvents = require('site/common/analytics/login-events');
  const isNewRegisterAPIsEnabled = _.contains(
    pageConfig.uiChannelFeatures,
    'USE_NEW_ACCOUNT_API'
  );

  if (pageConfig.alternateAppUri) {
    window.location = pageConfig.alternateAppUri;
  }

  require('jquery-validate');
  require('site/common/input-validation');

  var $content = $('.stand-alone.responsive');
  var $form = $('.password-reset form');
  var $input = $form.find('input[type=text], input[type=password]');
  var $requestButton = $form.find('button[type=submit]');
  var $serverErrorContainer = $('.form-errors');

  if (config.isMobile) {
    // Allow input field to be scrolled to top of window.
    if ($input.length) {
      $content.css('min-height', window.innerHeight + $input.offset().top);
    }

    // Ensure input field is visible, and not obscured by a virtual keyboard.
    $input.on('focus', function () {
      // The distance is somewhat arbitrary. It is a compromise between ensuring
      // visibility, and leaving some content above the input for context.
      window.scrollTo(0, $input.offset().top - 200);
    });
  }

  // Remove all server errors
  $form.on('submit', function () {
    $serverErrorContainer.find('.error').remove();
  });

  function initialisePasswordStrength() {
    events.on(
      events.PASSWORD_VALUE_CHANGED,
      ({passwordRules, passwordValue}) => {
        renderPasswordStrength(passwordRules, passwordValue);
      }
    );
  }

  function renderPasswordStrength(passwordRules, passwordValue = '') {
    ReactDOM.render(
      <PasswordStrength rules={passwordRules} passwordValue={passwordValue} />,
      document.querySelector('#pw-strength')
    );
  }

  function initialiseFormValidation($form, passwordRules) {
    var errorMessages = {
      passwordRequired:
        pageConfig.cms.validationErrors.passwordRequiredErrorMsg,
      password2Required:
        pageConfig.cms.validationErrors.password2RequiredErrorMsg,
      passwordMatch: pageConfig.cms.validationErrors.passwordMatchErrorMsg,
      emailRequired: pageConfig.cms.validationErrors.emailRequiredErrorMsg,
      validEmailRequired:
        pageConfig.cms.validationErrors.validEmailRequiredErrorMsg,
      passwordMinLength: pageConfig.cms.validationErrors.passwordMinLength,
    };

    const shouldUseNewValidation = isNewRegisterAPIsEnabled && passwordRules;
    if (shouldUseNewValidation) {
      const validatePasswordMethod = validatePassword(passwordRules);
      $.validator.addMethod('validatePassword', validatePasswordMethod, '');
      renderPasswordStrength(passwordRules);
    }

    var changePasswordValidators = {
      rules: {
        password: {
          required: true,
          minlength: 8,
        },
        password2: {
          required: true,
          equalTo: '#change-password-password1',
          //minlength: 8
        },
      },
      messages: {
        password: {
          required: errorMessages.passwordRequired,
          equalTo: errorMessages.passwordMatch,
          minlength: errorMessages.passwordMinLength,
        },
        password2: {
          required: errorMessages.password2Required,
          equalTo: errorMessages.passwordMatch,
          //minlength: errorMessages.passwordMinLength
        },
      },
    };

    if (shouldUseNewValidation) {
      changePasswordValidators.rules.password = {validatePassword: true};
      changePasswordValidators.onkeyup = function (element, event) {
        if (event.which === 9 && this.elementValue(element) === '') {
          return;
        } else if (
          element.name in this.submitted ||
          element === this.lastElement ||
          element.name === 'password'
        ) {
          this.element(element);
        }
      };
    }

    var requestPasswordValidators = {
      onfocusout: false,
      rules: {
        emailAddress: {
          required: true,
          email: true,
        },
      },
      messages: {
        emailAddress: {
          required: errorMessages.emailRequired,
          email: errorMessages.validEmailRequired,
        },
      },
    };

    if ($('.password-reset').hasClass('request-password')) {
      $form.validate(requestPasswordValidators);
    } else if ($('.password-reset').hasClass('change-password')) {
      $form.validate(changePasswordValidators);
    }
  }
  function addTrackingEventListener() {
    $requestButton.on('click', loginEvents.trackRequestPassword);
  }

  $(document).ready(function () {
    attachShowHidePasswordHandler({
      viewId: '#view-password-button, #view-password-button2',
      hideId: '#hide-password-button, #hide-password-button2',
      inputPasswordSelector:
        '#change-password-password1, #change-password-password2',
    });

    const initialiseForm = function (passwordRules) {
      initialiseFormValidation($form, passwordRules);
      addTrackingEventListener();
    };

    if (isNewRegisterAPIsEnabled) {
      const language =
        pageConfig.languageCode ||
        getLanguageCode(document.location.pathname) ||
        undefined;
      fetchPasswordRules({
        language,
        context: 'RESET',
        body: {},
      })
        .then((response) => {
          $('#pw-strength').addClass('pw-strength');
          renderPasswordStrength(response.passwordRules);
          initialisePasswordStrength();
          initialiseForm(response.passwordRules);
        })
        .catch(() => {
          initialiseForm();
        });
    } else {
      initialiseForm();
    }
  });
});
